// BurgerMenu Module
export const BurgerMenu = (() => {
	const defaults = {
		selector: ".burger",
		stateAttribute: "data-state",
		expandedAttribute: "aria-expanded",
		openState: "opened",
		closedState: "closed",
		openClass: "is-open",
	};

	const body = document.body;

	// Ferme le menu
	const closeBurger = (button, config) => {
		const targetId = button.getAttribute("aria-controls");
		const target = document.querySelector(`#${targetId}`);

		button.setAttribute(config.stateAttribute, config.closedState);
		button.setAttribute(config.expandedAttribute, "false");
		if (target) target.classList.remove(config.openClass);

		body.classList.remove("burger-menu-open");
	};

	// Toggle ouverture/fermeture
	const toggleBurgerState = (button, config) => {
		const currentState = button.getAttribute(config.stateAttribute);
		const targetId = button.getAttribute("aria-controls");
		const target = document.querySelector(`#${targetId}`);

		if (!currentState || currentState === config.closedState) {
			button.setAttribute(config.stateAttribute, config.openState);
			button.setAttribute(config.expandedAttribute, "true");
			if (target) target.classList.add(config.openClass);

			body.classList.add("burger-menu-open");
		} else {
			closeBurger(button, config);
		}
	};

	// Ferme le menu si clic sur un lien avec data-anchor
	const initAnchorLinks = (config) => {
		const anchors = document.querySelectorAll("[data-anchor]");
		anchors.forEach((anchor) => {
			anchor.addEventListener("click", () => {
				const burger = document.querySelector(config.selector);
				if (burger) closeBurger(burger, config);
			});
		});
	};

	// Initialisation
	const init = (userOptions = {}) => {
		const config = { ...defaults, ...userOptions };
		const buttons = document.querySelectorAll(config.selector);

		buttons.forEach((button) => {
			const targetId = button.getAttribute("aria-controls");
			const target = document.querySelector(`#${targetId}`);

			// Clic sur le bouton → toggle
			button.addEventListener("click", (e) => {
				e.stopPropagation();
				toggleBurgerState(button, config);
			});

			// Clic sur le menu mais pas dans le contenu → ferme
			if (target) {
				target.addEventListener("click", (e) => {
					if (e.target.closest(".extra-nav__ctn")) return;
					closeBurger(button, config);
				});
			}
		});

		// Active fermeture sur clic des liens anchor
		initAnchorLinks(config);
	};

	return { init, closeBurger, toggleBurgerState };
})();
